import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue";
import _imports_0 from '@/assets/放大镜.png';
const _hoisted_1 = {
  id: "div1",
  style: {
    "height": "100%",
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_2 = {
  style: {
    "height": "48px",
    "min-width": "370px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "183px 0 0 650px",
    "background": "white",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  id: "datePicker3",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "183px 0 0 1440px",
    "border-radius": "15px",
    "border": "1px solid #002483",
    "overflow": "hidden",
    "height": "45px",
    "width": "200px"
  }
};
const _hoisted_4 = {
  style: {
    "overflow": "hidden",
    "height": "776px",
    "width": "1516px",
    "border": "none",
    "background": "white",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "261px 0 0 356px",
    "font-size": "21px"
  }
};
const _hoisted_5 = ["onDblclick"];
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = ["onMouseover", "onMouseleave"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  ref: "fixedHeader",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "height": "100px",
    "background": "white",
    "border-bottom": "1px solid #dcdfe6",
    "white-space": "nowrap"
  }
};
const _hoisted_10 = {
  style: {
    "background": "none",
    "border": "none",
    "font-weight": "bold"
  }
};
const _hoisted_11 = {
  style: {
    "background": "none",
    "border": "none",
    "font-weight": "bold"
  }
};
const _hoisted_12 = {
  ref: "fixedColumn",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "width": "180px",
    "background": "white",
    "border-right": "1px solid #dcdfe6",
    "overflow": "hidden"
  }
};
const _hoisted_13 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "left",
    "margin": "0 0px 0 20px",
    "width": "29px"
  }
};
const _hoisted_14 = ["value"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  style: {
    "height": "100px",
    "width": "180px",
    "background": "white",
    "border-right": "1px solid #dcdfe6",
    "border-bottom": "1px solid #dcdfe6",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_17 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_18 = {
  key: 0,
  style: {
    "height": "790px",
    "width": "875px",
    "margin": "170px 0 0 520px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "background": "white",
    "border-radius": "10px",
    "box-shadow": "#666 0px 0px 10px",
    "overflow": "hidden"
  }
};
const _hoisted_19 = {
  style: {
    "margin": "40px 0 0 0",
    "width": "100%",
    "display": "flex"
  }
};
const _hoisted_20 = {
  key: 0,
  id: "div2",
  style: {
    "margin": "0px 0 0 0",
    "position": "absolute",
    "bottom": "-2px",
    "right": "-2px",
    "height": "45px",
    "width": "45px"
  }
};
const _hoisted_21 = {
  id: "datePicker",
  style: {
    "margin": "10px 0 0 25px"
  }
};
const _hoisted_22 = {
  style: {
    "margin": "20px 0 0 25px",
    "width": "330px"
  }
};
const _hoisted_23 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 0",
    "border": "none"
  }
};
const _hoisted_24 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_25 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 40px"
  }
};
const _hoisted_26 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_27 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 40px"
  }
};
const _hoisted_28 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_29 = {
  style: {
    "margin": "20px 0 0 25px",
    "width": "330px"
  }
};
const _hoisted_30 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 0",
    "border": "none"
  }
};
const _hoisted_31 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_32 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 40px"
  }
};
const _hoisted_33 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_34 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 40px"
  }
};
const _hoisted_35 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_36 = {
  style: {
    "margin": "20px 0 0 25px",
    "width": "330px"
  }
};
const _hoisted_37 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0px 0 0 0",
    "border": "none"
  }
};
const _hoisted_38 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "margin": "0 0px 0 0px"
  }
};
const _hoisted_39 = {
  key: 1,
  id: "weekDaysSelect"
};
const _hoisted_40 = {
  key: 0,
  id: "div2",
  style: {
    "margin": "0px 0 0 0",
    "position": "absolute",
    "bottom": "-2px",
    "right": "-2px",
    "height": "45px",
    "width": "45px"
  }
};
const _hoisted_41 = {
  id: "datePicker2"
};
const _hoisted_42 = {
  key: 0,
  style: {
    "margin": "10px 0 0 25px",
    "width": "330px",
    "max-height": "65px",
    "overflow-y": "auto",
    "border": "1px solid #dcdfe6",
    "border-radius": "4px",
    "padding": "10px",
    "background": "#f5f7fa"
  }
};
const _hoisted_43 = {
  style: {
    "margin": "10px 0 0 25px",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_44 = {
  style: {
    "font-size": "15px",
    "display": "flex",
    "align-items": "center",
    "margin": "0 10px 0 0"
  }
};
const _hoisted_45 = {
  style: {
    "font-size": "15px",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_46 = {
  style: {
    "margin": "10px 0 0 25px",
    "display": "flex",
    "align-items": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
    class: "searchInput",
    placeholder: '搜索老师',
    style: {
      "height": "48px",
      "width": "355px",
      "font-size": "15px",
      "color": "#717579",
      "margin": "0px 0 0 0px"
    },
    modelValue: $data.searchStr,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchStr = $event),
    onInput: _cache[1] || (_cache[1] = $event => $options.search())
  }, null, 8, ["modelValue"]), _cache[43] || (_cache[43] = _createElementVNode("img", {
    src: _imports_0,
    style: {
      "height": "27px",
      "width": "27px",
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "margin": "10.5px 0 0 300px"
    }
  }, null, -1))]), _cache[58] || (_cache[58] = _createElementVNode("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "183px 0 0 1310px",
      "background": "white",
      "height": "45px",
      "width": "335px"
    }
  }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_date_picker, {
    modelValue: $data.selectedMonth,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.selectedMonth = $event),
    type: "month",
    placeholder: "选择年月",
    format: "YYYY-MM",
    "value-format": "YYYY-MM",
    style: {
      "width": "100%",
      "height": "100%",
      "padding": "0 0 0 0px",
      "overflow": "hidden",
      "background": "#edf1fb"
    },
    onChange: $options.handleMonthChange
  }, null, 8, ["modelValue", "onChange"])]), _createElementVNode("div", {
    style: {
      "height": "43px",
      "width": "159px",
      "border": "none",
      "background": "none",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "182px 0 0 1664px"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[3] || (_cache[3] = $event => $options.setVacation())
  }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    id: "scrollArea",
    style: {
      "width": "100%",
      "height": "100%",
      "overflow": "auto",
      "white-space": "nowrap"
    },
    onScroll: _cache[4] || (_cache[4] = (...args) => $options.handleScroll && $options.handleScroll(...args))
  }, [_cache[46] || (_cache[46] = _createElementVNode("div", {
    style: {
      "height": "100px"
    }
  }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {}
    }, [_cache[45] || (_cache[45] = _createElementVNode("div", {
      style: {
        "width": "180px",
        "display": "inline-block",
        "vertical-align": "top"
      }
    }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.monthDates, (item2, index2) => {
      return _openBlock(), _createElementBlock("div", {
        key: index2,
        style: {
          "display": "inline-block",
          "vertical-align": "top",
          "white-space": "nowrap"
        }
      }, [_createElementVNode("div", {
        style: {
          "border-right": "1px solid #dcdfe6",
          "border-bottom": "1px solid #dcdfe6",
          "height": "80px",
          "width": "90px"
        },
        onDblclick: $event => $options.doubleClickUnit(index, index2),
        onmouseover: "this.style.cursor='pointer'"
      }, [$data.vacationList[item.id] && $data.vacationList[item.id][item2.completeDate] && $data.vacationList[item.id][item2.completeDate][0] != $data.vacationList[item.id][item2.completeDate][1] ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        style: _normalizeStyle(`
                    height: ${80 * ($data.vacationList[item.id][item2.completeDate][0] - 0) / 24}px;
                    width: 90px;

                    
                  `)
      }, null, 4), _createVNode(_component_el_tooltip, {
        content: `
                  休假时间：
                  ${$data.vacationList[item.id][item2.completeDate][0].toString().padStart(2, '0')}:00
                  -
                  ${$data.vacationList[item.id][item2.completeDate][1].toString().padStart(2, '0')}:00 (${$data.vacationReason[item.id][item2.completeDate] ? $data.vacationReason[item.id][item2.completeDate] : ''})
                  `,
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          style: _normalizeStyle(`
                    border: 1px solid #dcdfe6;
                    background-image: linear-gradient(
                    45deg,
                    #f4f7fd 25%,
                    transparent 25%,
                    transparent 50%,
                    #f4f7fd 50%,
                    #f4f7fd 75%,
                    transparent 75%,
                    transparent
                    );

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    height: ${80 * ($data.vacationList[item.id][item2.completeDate][1] - $data.vacationList[item.id][item2.completeDate][0]) / 24}px;
                    width: 90px;

                    position: relative;

                  `),
          onMouseover: $event => $options.showDeleteVacationButton(index, index2),
          onMouseleave: $event => $options.hiddenDeleteVacationButton(index, index2)
        }, [_cache[44] || (_cache[44] = _createElementVNode("div", {
          style: {
            "height": "100%",
            "width": "100%",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center"
          }
        }, " 休假 ", -1)), $data.showDeleteVacation[index] && $data.showDeleteVacation[index][index2] ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {
            "height": "20px",
            "width": "20px",
            "color": "white",
            "font-size": "20px",
            "line-height": "15px",
            "text-align": "center",
            "border-radius": "50%",
            "background": "red",
            "margin": "0px 0px 0px 0px",
            "position": "absolute",
            "top": "0",
            "right": "0"
          },
          onmouseover: "this.style.cursor='pointer'",
          onClick: $event => $options.deleteVacation(index, index2)
        }, " x ", 8, _hoisted_8)) : _createCommentVNode("", true)], 44, _hoisted_7)]),
        _: 2
      }, 1032, ["content"])])) : _createCommentVNode("", true)], 40, _hoisted_5)]);
    }), 128))]);
  }), 128))], 32), _createElementVNode("div", _hoisted_9, [_cache[47] || (_cache[47] = _createElementVNode("div", {
    style: {
      "height": "100%",
      "width": "180px",
      "display": "inline-block",
      "vertical-align": "top"
    }
  }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.monthDates, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "height": "100%",
        "width": "90px",
        "background": "none",
        "border": "none",
        "display": "inline-block",
        "vertical-align": "top",
        "font-weight": "bold"
      }
    }, [_createElementVNode("div", {
      style: _normalizeStyle([{
        "height": "100%",
        "width": "90px",
        "background": "none",
        "border": "none",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "align-items": "center",
        "font-weight": "bold"
      }, `background:${item.completeDate == $data.todayDate ? '#d5d8e1' : 'none'}`])
    }, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.date), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.dayOfWeekText), 1)], 4)]);
  }), 128))], 512), _createElementVNode("div", _hoisted_12, [_cache[48] || (_cache[48] = _createElementVNode("div", {
    style: {
      "height": "100px",
      "width": "100%",
      "background": "white",
      "border": "none",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "font-weight": "bold"
    }
  }, "   ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "height": "80px",
        "width": "180px",
        "background": "white",
        "border": "none",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "font-weight": "bold"
      }
    }, [_createElementVNode("label", _hoisted_13, [_withDirectives(_createElementVNode("input", {
      style: {
        "height": "25px",
        "width": "25px"
      },
      type: "checkbox",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.selectedTeacherIds = $event),
      value: item.id,
      onChange: _cache[6] || (_cache[6] = $event => $options.selectTeacher()),
      onmouseover: "this.style.cursor='pointer'"
    }, null, 40, _hoisted_14), [[_vModelCheckbox, $data.selectedTeacherIds]])]), _createElementVNode("div", {
      style: {
        "height": "80px",
        "width": "100px",
        "margin": "0 0 0 20px",
        "background": "white",
        "border": "none",
        "display": "flex",
        "align-items": "center",
        "justify-content": "left",
        "font-weight": "bold"
      },
      onClick: $event => $options.clickTeacherName(item.id),
      onmouseover: "this.style.cursor='pointer'"
    }, _toDisplayString(item.name), 9, _hoisted_15)]);
  }), 128))], 512), _createElementVNode("div", _hoisted_16, [_createElementVNode("label", _hoisted_17, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.selectedAll = $event),
    value: true,
    onChange: _cache[8] || (_cache[8] = $event => $options.selectAllTeacher()),
    onmouseover: "this.style.cursor='pointer'"
  }, null, 544), [[_vModelCheckbox, $data.selectedAll]])]), _createElementVNode("div", {
    style: {
      "height": "80px",
      "margin": "0 0 0 20px",
      "background": "white",
      "border": "none",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "font-weight": "bold"
    },
    onClick: _cache[9] || (_cache[9] = $event => $options.clickSelectAllWord()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 全选 ")])]), $data.showSetVacation ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[56] || (_cache[56] = _createElementVNode("div", {
    style: {
      "margin": "25px 0 0 40px",
      "background": "white",
      "font-size": "27px",
      "font-weight": "bold"
    }
  }, " 设置休息时间 ", -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    style: _normalizeStyle([{
      "margin": "0 0 0 40px",
      "border-radius": "15px",
      "box-shadow": "#666 0px 0px 10px",
      "height": "330px",
      "width": "380px",
      "position": "relative"
    }, {
      border: $data.ifFixedRest == 'true' ? '3px solid #0d2f89' : '3px solid white'
    }]),
    onClick: _cache[33] || (_cache[33] = $event => $options.changeIfFixedRest('fixed')),
    onmouseover: "this.style.cursor='pointer'"
  }, [$data.ifFixedRest == 'true' ? (_openBlock(), _createElementBlock("div", _hoisted_20)) : _createCommentVNode("", true), _createElementVNode("div", {
    style: _normalizeStyle([{
      "margin": "15px 0 0 25px",
      "font-size": "25px",
      "font-weight": "bold"
    }, {
      color: $data.ifFixedRest == 'true' ? '#1b48bb' : 'grey'
    }])
  }, " 固定周几休息 ", 4), _cache[49] || (_cache[49] = _createElementVNode("div", {
    style: {
      "height": "2px",
      "width": "100%",
      "background": "#ededed"
    }
  }, null, -1)), _cache[50] || (_cache[50] = _createElementVNode("div", {
    style: {
      "margin": "15px 0 0 25px",
      "color": "grey",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, " 起止时间 ", -1)), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_date_picker, {
    modelValue: $data.vacationRange,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.vacationRange = $event),
    type: "daterange",
    "range-separator": "至",
    "start-placeholder": "开始日期",
    "end-placeholder": "结束日期",
    format: "YYYY-MM-DD",
    "value-format": "YYYY-MM-DD",
    style: {
      "width": "330px",
      "height": "50px",
      "border-radius": "10px"
    },
    locale: $setup.zhCn,
    disabled: $data.ifFixedRest == 'false'
  }, null, 8, ["modelValue", "locale", "disabled"])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("label", _hoisted_24, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.selectedWeekDays = $event),
    value: '1',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[12] || (_cache[12] = $event => $options.selectWeekday('1'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[13] || (_cache[13] = $event => $options.clickWeekdayWord('1'))
  }, " 周一 ")]), _createElementVNode("div", _hoisted_25, [_createElementVNode("label", _hoisted_26, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0 0px 0 0px"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.selectedWeekDays = $event),
    value: '2',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[15] || (_cache[15] = $event => $options.selectWeekday('2'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[16] || (_cache[16] = $event => $options.clickWeekdayWord('2'))
  }, " 周二 ")]), _createElementVNode("div", _hoisted_27, [_createElementVNode("label", _hoisted_28, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0 0px 0 0px"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.selectedWeekDays = $event),
    value: '3',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[18] || (_cache[18] = $event => $options.selectWeekday('3'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[19] || (_cache[19] = $event => $options.clickWeekdayWord('3'))
  }, " 周三 ")])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("label", _hoisted_31, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.selectedWeekDays = $event),
    value: '4',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[21] || (_cache[21] = $event => $options.selectWeekday('4'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[22] || (_cache[22] = $event => $options.clickWeekdayWord('4'))
  }, " 周四 ")]), _createElementVNode("div", _hoisted_32, [_createElementVNode("label", _hoisted_33, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0 0px 0 0px"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.selectedWeekDays = $event),
    value: '5',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[24] || (_cache[24] = $event => $options.selectWeekday('5'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[25] || (_cache[25] = $event => $options.clickWeekdayWord('5'))
  }, " 周五 ")]), _createElementVNode("div", _hoisted_34, [_createElementVNode("label", _hoisted_35, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0 0px 0 0px"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.selectedWeekDays = $event),
    value: '6',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[27] || (_cache[27] = $event => $options.selectWeekday('6'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[28] || (_cache[28] = $event => $options.clickWeekdayWord('6'))
  }, " 周六 ")])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("label", _hoisted_38, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px",
      "margin": "0"
    },
    type: "checkbox",
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.selectedWeekDays = $event),
    value: '7',
    onmouseover: "this.style.cursor='pointer'",
    onChange: _cache[30] || (_cache[30] = $event => $options.selectWeekday('7'))
  }, null, 544), [[_vModelCheckbox, $data.selectedWeekDays]])]), _createElementVNode("div", {
    style: {
      "height": "25px",
      "line-height": "25px",
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black",
      "margin": "0px 0 0 10px",
      "display": "inline-block",
      "vertical-align": "top"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[31] || (_cache[31] = $event => $options.clickWeekdayWord('7'))
  }, " 周日 ")])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_el_select, {
    modelValue: _ctx.selectedWeekDays1,
    "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => _ctx.selectedWeekDays1 = $event),
    multiple: "",
    placeholder: "请选择周一到周日",
    style: {
      "margin": "10px 0 0 25px",
      "height": "60px",
      "width": "330px"
    },
    disabled: $data.ifFixedRest === 'false'
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekDays, day => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: day.value,
        label: day.label,
        value: day.value,
        style: {
          "font-size": "15px",
          "height": "20px",
          "line-height": "20px",
          "width": "200px"
        }
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true)], 4), _createElementVNode("div", {
    style: _normalizeStyle([{
      "margin": "0 0 0 35px",
      "border-radius": "15px",
      "box-shadow": "#666 0px 0px 10px",
      "position": "relative",
      "height": "330px",
      "width": "380px"
    }, {
      border: $data.ifFixedRest == 'false' ? '3px solid #0d2f89' : '3px solid white'
    }]),
    onClick: _cache[39] || (_cache[39] = $event => $options.changeIfFixedRest('unfixed')),
    onmouseover: "this.style.cursor='pointer'"
  }, [$data.ifFixedRest == 'false' ? (_openBlock(), _createElementBlock("div", _hoisted_40)) : _createCommentVNode("", true), _createElementVNode("div", {
    style: _normalizeStyle([{
      "margin": "15px 0 0 25px",
      "font-size": "25px",
      "font-weight": "bold"
    }, {
      color: $data.ifFixedRest == 'false' ? '#1b48bb' : 'grey'
    }])
  }, " 非固定休息 ", 4), _cache[54] || (_cache[54] = _createElementVNode("div", {
    style: {
      "height": "2px",
      "width": "100%",
      "background": "#ededed"
    }
  }, null, -1)), _cache[55] || (_cache[55] = _createElementVNode("div", {
    style: {
      "margin": "15px 0 0 25px",
      "color": "grey",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, " 选择日期 ", -1)), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_date_picker, {
    modelValue: $data.selectedDates,
    "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.selectedDates = $event),
    type: "dates",
    format: "YYYY-MM-DD",
    "value-format": "YYYY-MM-DD",
    placeholder: "请选择日期",
    style: {
      "margin": "10px 0px 0 25px",
      "width": "330px",
      "min-height": "50px"
    },
    "disabled-date": $options.disabledDate,
    disabled: $data.ifFixedRest === 'true'
  }, null, 8, ["modelValue", "disabled-date", "disabled"]), $data.selectedDates && $data.selectedDates.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedDates, (date, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "display": "inline-block",
        "margin": "2px 5px 2px 5px",
        "padding": "2px 2px 2px 2px",
        "background": "#ecf5ff",
        "border": "1px solid #b3d8ff",
        "border-radius": "4px",
        "font-size": "14px"
      }
    }, _toDisplayString(date), 1);
  }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("label", _hoisted_44, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px"
    },
    type: "radio",
    "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.ifTotalDay = $event),
    value: "true"
  }, null, 512), [[_vModelRadio, $data.ifTotalDay]]), _cache[51] || (_cache[51] = _createTextVNode(" 全天 ", -1))]), _createElementVNode("label", _hoisted_45, [_withDirectives(_createElementVNode("input", {
    style: {
      "height": "25px",
      "width": "25px"
    },
    type: "radio",
    "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.ifTotalDay = $event),
    value: "false"
  }, null, 512), [[_vModelRadio, $data.ifTotalDay]]), _cache[52] || (_cache[52] = _createTextVNode(" 自定义时间段 ", -1))])]), _createElementVNode("div", _hoisted_46, [_createVNode(_component_el_select, {
    modelValue: $data.startTime,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $data.startTime = $event),
    placeholder: "开始时间",
    style: {
      "height": "30px",
      "width": "100px",
      "margin": "0 5px 0 0px",
      "font-size": "19px"
    },
    disabled: $data.ifTotalDay == 'true'
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.startHourOptions, hour => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: hour,
        value: hour.toString().padStart(2, '0') + ':00'
      }, null, 8, ["value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "disabled"]), _cache[53] || (_cache[53] = _createElementVNode("span", {
    style: {
      "margin": "0 5px 0 5px",
      "font-size": "19px"
    }
  }, "至", -1)), _createVNode(_component_el_select, {
    modelValue: $data.endTime,
    "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.endTime = $event),
    placeholder: "结束时间",
    style: {
      "height": "30px",
      "width": "100px",
      "margin": "0 10px 0 5px",
      "font-size": "19px"
    },
    disabled: $data.ifTotalDay == 'true'
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.endHourOptions, hour => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: hour,
        value: hour.toString().padStart(2, '0') + ':00'
      }, null, 8, ["value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "disabled"])])], 4)]), _cache[57] || (_cache[57] = _createElementVNode("div", {
    style: {
      "margin": "30px 0 0 40px",
      "font-size": "20px",
      "width": "436px"
    }
  }, " 休假原因 ", -1)), _withDirectives(_createElementVNode("textarea", {
    style: {
      "margin": "10px 0 0 40px",
      "width": "795px",
      "height": "150px",
      "border-radius": "15px",
      "font-size": "20px",
      "padding": "5px",
      "overflow-y": "auto"
    },
    type: "text",
    "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.reason = $event)
  }, null, 512), [[_vModelText, $data.reason]]), _createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "200px",
      "font-size": "20px",
      "border-radius": "10px",
      "background": "#1b48bb",
      "color": "white",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "699px 0 0 213px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[41] || (_cache[41] = $event => $options.saveVacationSetting()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 确认 "), _createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "200px",
      "font-size": "20px",
      "color": "#0091ff",
      "border": "1px solid #0091ff",
      "border-radius": "10px",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "699px 0 0 462px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[42] || (_cache[42] = $event => $options.cancelVacationSetting()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 取消 ")])) : _createCommentVNode("", true)]);
}